import withCommunityErrorBoundary from './withCommunityErrorBoundary'

export { withCommunityErrorBoundary }
export default withCommunityErrorBoundary
